import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// La configuration des traductions
const resources = {
  en: {
    translation: {
      meta: {
        description: "Optimize your staff management with our intuitive scheduling app. Create and assign shifts in just a few clicks.",
        descriptionNews: "Discover the latest news from Schedulum: new features, product updates, tips for managing schedules and team planning for SMEs.",
        descriptionHelp: "Get help with Schedulum: see features, product updates, and best practices for scheduling and team planning for small and medium-sized businesses.",
        descriptionDetails: "Full details on Schedulum software: features, product updates, tips for managing schedules and team planning for SMEs.",
        descriptionSignUp: "Register to use the Schedulum software: features, product updates, tips for managing schedules and team planning for SMEs.",
        descriptionConfirmEmail: "Confirm your email to use your Schedulum software account: features, product updates, tips for managing schedules and team planning for SMEs.",
        ogTitle: "Scheduling software for SMEs | Schedulum",
        ogTitleNews: "News on the scheduling software for SMEs | Schedulum",
        ogTitleHelp: "Help on scheduling software for SMEs | Schedulum",
        ogTitleDetails: "Details on scheduling software for SMEs | Schedulum",
        ogTitleSignUp: "Registration form | Schedulum ",
        ogTitleConfirmEmail: "Email confirmation form | Schedulum",
        ogDescription: "Save time managing your schedules, absences, and team communication. 30-day free trial.",
        ogDescriptionNews: "All the essential information about Schedulum: feature releases, planning tips, and important announcements for SMEs.",
        ogDescriptionHelp: "All the essential help about Schedulum: feature releases, planning tips, and important announcements for SMEs.",
        ogDescriptionDetails: "All the interesting details about Schedulum: feature releases, planning tips, and important announcements for SMEs.",
        ogDescriptionSignUp: "Register to use the Schedulum services",
        ogDescriptionConfirmEmail: "Email confirmation for your Schedulum account",
        ogType: "website",
        ogTypeNews: "website",
        ogTypeHelp: "website",
        ogTypeDetails: "website",
        ogTypeSignUp: "website",
        ogTypeConfirmEmail: "website",
        ogUrl: "https://schedulum.org",
        ogUrlNews: "https://schedulum.org/news",
        ogUrlHelp: "https://schedulum.org/help",
        ogUrlDetails: "https://schedulum.org/details",
        ogUrlSignUp: "https://www.schedulum.org/signup",
        ogUrlConfirmEmail: "https://www.schedulum.org/confirmEmail",
        ogImage: "https://schedulum.org/SEO/homepage.png",
        ogImageNews: "https://schedulum.org/SEO/news.png",
        ogImageHelp: "https://schedulum.org/SEO/help.png",
        ogImageDetails: "https://schedulum.org/SEO/details.png",
        ogImageSignUp: "https://schedulum.org/SEO/signup.png",
        ogImageConfirmEmail: "https://schedulum.org/SEO/confirmEmail.png",
        markupName: "Schedulum - Employee scheduling and HR management",
        markupNameNews: "Schedulum - News on employee scheduling and HR management",
        markupNameHelp: "Schedulum - Help on employee scheduling and HR management",
        markupNameDetails: "Schedulum - Details on employee scheduling and HR management",
        markupNameSignUp: "Schedulum - Sign up on the employee scheduling and HR management software",
        markupNameConfirmEmail: "Schedulum - Confirm email tu use the on employee scheduling and HR management sowtware",
        markupDescription: "Smart, fast employee scheduling and time tracking software for small to medium-sized businesses.",
        markupDescriptionNews: "News on a smart, fast employee scheduling and time tracking software for small to medium-sized businesses.",
        markupDescriptionHelp: "Help on a smart, fast employee scheduling and time tracking software for small to medium-sized businesses.",
        markupDescriptionDetails: "Details on a smart, fast employee scheduling and time tracking software for small to medium-sized businesses.",
        markupDescriptionSignUp: "Sign up on a smart, fast employee scheduling and time tracking software for small to medium-sized businesses.",
        markupDescriptionConfirmEmail: "Confirm email tu use a smart, fast employee scheduling and time tracking software for small to medium-sized businesses.",
      },
      image: {
        team_work: "Team work",
        hr_team: "Human resources",
        prod_eff: "Production and efficiency",
        dashboard_mobile: "mobile applciation",
        agenda_manager: "calendar management",
        sidebar_option: "options and settings",
        gmaps: "GPS positioning",
        posts: "Messaging",
        scheduler: "Scheduler",
        punch_gps: "Check-in and check-out with GPS coordinates",
        upload_table: "Upload shifts table",
        agenda: "Agenda",
        request: "Ask request",
        leave: "Ask leave",
        desktop: "Dashboard",
        document: "Documents",
        swap: "Transfer shifts",
        options: "Sidebar and options",
        boxplot: "Box graphic",
        barplot: "Bar graphic",
        heatmap: "Map by heat zone",
        ai_recommendation: "AI recommendation",
        spyder_radar: "Spyder radar",
        com_posts: "Messaging system",
        com_leave_requests: "Leave request system",
        com_swap_requests: "Swap request system",
        appStore: "Download on the App Store",
        gplay: "Get it on Google Play",
      },
      link: {
        dashboard: "/dashboard",
        news: "/news",
        user: "/user",
        users: "/users",
        help: "/help",
        signin: "/signin",
        signup: "/signup",
        posts: "/messages",
        shifts: "/shifts",
        shift: "/shift",
        open_shifts: "/open_shifts",
        scheduler: "/scheduler",
        settings: "/settings",
        swap_create: "/requests/swap/create/shift/",
        suggested_requests_swap: "/suggestedUser/requests/swaps",
        requests_swap: "/requests/swaps",
        requests_leave: "/requests/leaves",
        leave_create: "/requests/leave/create",
        swap_management: "/requests/management/swaps",
        leave_management: "/requests/management/leaves",
        agenda_management: "/agenda/management",
        add_worker: "/add/workers",
        billing: "/billing",
        company: '/company',
        company_create: '/create/company',
        table_shift: "/table/shift",
        excel_shift: "/excel_import/shift",
        table_open_shift: "/table/open_shift",
        excel_open_shift: "/excel_import/open_shift",
        map: "/map/",
        worker: "/worker",
        edit: "edit",
        coworkers: "coworkers",
        management: "gestion",
      },
      title: {
        dashboard: "Dashboard",
        home: "Job Shift Scheduling Software | Manage Employee Schedules | Schedulum",
        blog: "Job Shift Scheduling Software Blog And News | Manage Employee Schedules Blog And News | Schedulum",
        help: "Help on Job Shift Scheduling Software Blog And News | Help Managing Employee Schedules Blog And News | Schedulum",
        details: "Details on Job Shift Scheduling Software Blog And News | Details on Managing Employee Schedules Blog And News | Schedulum",
        scheduler: "Job Shift Scheduler Software | Manage Employee Schedules",
        agenda: "Job Shift Agenda Software | Manage Employee Schedules And Agenda",
        management: "Job Shift Agenda Management Software | Manage Employee Schedules And Agenda",
        billing: "Billing",
        signin: "Sign In Scheduler | Log In Scheduler",
        signout: "Sign Out Scheduler | Log Out Scheduler",
        signup: "Sign Up Schedulum | Register Schedulum ",
        forgotPassword: "Forgot Password | Schedulum",
        newPassword: "New Password | Schedulum",
        confirmEmail: "Confirm Email | Schedulum",
        createCompany: "Create Company | Schedulum",
        addWorkers: "Add Workers | Schedulum",
        userShift: " Shifts",
        shift: "Shift",
        shifts: "Shifts",
        openshifts: "Open Shifts",
        spreadsheet: "Upload Table | Schedulum",
        table: "Paste Table",
        users: "Users",
        user: "User",
        swap_requests: "Swap Requests",
        leave_requests: "Leave Requests",
        request: "Request",
        terms: "Terms of Use | Schedulum",
      },
      error: {
        "goHome": "Return to Home Page",
        "users_required": "User required",
        "dates_required": "Dates required",
        "role_required": "Role required",
        "info_required": "Info required",
        "location_required": "Location required",
      },
      dashboard: {
        "linkedCompanyTitle": "Lien Entreprise Manquant",
        "linkedCompany": "Vous devez être associé à une entrerpise",
      },
      navBar: {
        "language": "Language",
        "help": "Help",
        "tools": "Tools",
        "users": "Users",
        "dashboard": "Dashboard",
        "news": "News",
        "table": "Paste Table",
        "spreadsheet": "Upload Table",
        "scheduler": "Scheduler",
        "agenda": "Agenda",
        "agendaManager": "Agenda Management",
        "email": "Email",
        "password": "Password",
        "login": "Log In",
        "signup": "Sign Up",
        "signout": "Sign Out",
        "shift": "Shift",
        "open_shift": "Open Shift",
        "settings": "Settings",
        "documents": "Document Manager",
        "myDocuments": "Documents",
        "shifts": "Shifts",
        "open_shifts": "Open Shifts",
        "posts": "Messages",
        "request": "Requests",
        "suspendUser": "Suspend worker",
        "unsuspendUser": "Unsuspend worker"
      },
      home: {
        "title": "The Best Application for Shift Assignment and Scheduling",
        "subtitle1": "Simplify your staff management with an intuitive scheduling system",
        "subtitle1_message1": "Are you tired of juggling spreadsheets, phone calls, and last-minute requests to build your team's work schedules? Stop wasting time and energy on a complicated process. Schedulum is the intuitive solution designed to simplify your day-to-day HR tasks.",
        "subtitle1_message2": "Our application gives you complete control over your schedules, allowing you to create and share them with your employees in just a few clicks. No more communication issues or confusion. Your team can view their schedules in real time, request time off, and swap shifts with colleagues, all from a single, easy-to-use platform.",
        "subtitle1_message3": "By automating your planning, Schedulum allows you to focus on what really matters: growing your business. Reduce administrative errors, improve communication within your team, and increase productivity.",
        "subtitle1_message4": "Take control of your schedules and free up your time for good.",
        "subtitle1_message5": "Try Schedulum for free today and transform the way you work.",
        "subtitle2": "Discover the key features of our scheduling software",
        "subtitle2_message1": "Looking to transform your team management? Our app is much more than just a calendar. It's a real asset for your productivity and employee satisfaction. Discover the features that make the difference :",
        "subtitle2_message2": "Smart, Fast Scheduling: Create team schedules in minutes, not hours. Our intuitive interface lets you view availability, time off, and skills at a glance for optimal assignment.",
        "subtitle2_message3": "Centralized Communication: No more lost calls and messages. Our app integrates an internal communication system so employees can communicate with each other and their manager. Automatic notifications ensure everyone is informed of real-time updates.",
        "subtitle2_message4": "Human Resources Management: Centralize your staff information, track hours, and export payroll data with ease. These automated features reduce administrative errors and save you valuable time.",
        "subtitle2_message5": "Performance Analytics: Make informed decisions with analytical dashboards. Get a comprehensive view of hours worked, labor costs, and productivity.",
        "subtitle2_message6": "With our service, you don't just manage schedules, you optimize your operations.",
        "subtitle3": "How our software helps SMEs",
        "subtitle3_message1": "Small and medium-sized businesses (SMBs) face a unique challenge: maximizing their productivity without the resources of larger corporations. Our software is designed specifically for you. It helps you overcome everyday obstacles and focus your energy on growing your business.",
        "subtitle3_message2": "Solve planning problems",
        "subtitle3_message3": "Time is money. Every minute spent juggling Excel spreadsheets and messages to schedule your teams is a minute wasted. Our solution allows you to create and manage schedules in minutes. You gain efficiency and accuracy, which reduces payroll errors and scheduling conflicts.",
        "subtitle3_message4": "Reduced errors: Scheduling software automatically detects schedule conflicts and overlaps to prevent errors before the schedule is even published.",
        "subtitle3_message5": "Optimized working time: Our system gives you a clear overview of hours worked, leave, and employee availability, which helps you make smarter staffing decisions.",
        "subtitle3_message6": "Improve internal communication",
        "subtitle3_message7": "Improve communication: Good communication is the driving force behind an effective team. Our software centralizes all schedule-related communications, eliminating the need to use multiple messaging platforms.",
        "subtitle3_message8": "Instant Notifications: Inform your employees of shift changes in real-time via direct notifications.",
        "subtitle3_message9": "Simplified swaps: Your employees can request shift swaps or time off directly from the app, making the process transparent and easy to manage for everyone.",
        "subtitle3_message10": "Ultimately, our software doesn't just manage schedules, it gives you control over your operations and allows you to create a more productive and harmonious work environment.",
        "linkedCompany": "... You need to be linked to a Company ...",
        "noShiftAvail": "No current Shift Avalaible",
        "manageShift": " Manage Shifts ",
        "upcomingShift": " Upcoming Shifts ",
        "manageOpenShift": " Manage Open Shifts ",
        "openShiftAvail": " Open Shifts Avalaible ",
        "openPublicShiftAvail": " Public Open Shifts Avalaible ",
        "openShift": " Open Shifts ",
        "scheduler": "Scheduler",
        "shiftReceived": " Shifts Received ", 
        "newsFeed": " News Feed ",
        "currentShift": "Current Shift",
        "startAt": "Start at:  ",
        "stopAt": "Stop at:  ",
        "uploadDocTitle": "Documents",
        "uploadDoc": "Do you want to get or upload documents?",
        "goToDoc": "Your documents",
        "goToDocManager": "Document Management",
        "notWorkingTitle": "You're not currently working",
        "notWorking": "Please punch when you want to start or stop your time on a current shift",
        "shiftToFarTitle": "Your shift is too far to begin",
        "shiftToFar": "You have to start your shift less then 30 minutes before it should start",
        "wantToPunchTitle": "Do you want to punch",
        "wantToPunch": "Are you sure you want to punch on your current Shift?",
        "beenSuspended": "You have been suspended",
        "apply": "Apply",
        "no_shift": "No shift to come.",
        "safariNotificationTitle": "Notifications Management",
        "safariNotificationStatus": "Actual permission status : ",
        "discoverDesign": "Select a User Interface", 
        "backDashboard": "Go To Dashboard",
        "suspendNow": "Suspend Now",
        "unsuspendNow": "Reactivate"
      },
      homepage: {
        banner: {
          titleAcheive: "Stronger Together",
          acheive: "Acheive your goals.",
          titleTeam: "Team Work",
          team: "Complicity and atmosphere.",
          titleProd: "Planning with HR",
          prod: "Productivity and efficiency to be succesfull."
        },
        card: {
          "hr": "Human Resources",
          "hr_content": "Centralize your HR. Onboarding employees records, and surveys. Track your employee work hours. Punch clock, timesheets, and payroll export.",
          "stat": "Analyze your staff",
          "stat_content": "Give points to the workers and analyze their forces to improve the services you are offering. The easiest way to use your employees at their best.",
          "communication": "Improve communications",
          "com_content": "Professional chat, internal news feeds, and automatic notifications. You can alose ask for request and trade your shifts inside your working team.",
          "more_details": "More Details",
        },
        "start_scheduling": "Start scheduling",
        "in_minutes": "in minutes",
        "try_free": "Try it free",
        help_video: "Video Examples",
      },
      signup: {
        "type_invalid": "This type is not valid.",
        "type_required": "You must choose a type.",
        "accepted_terms_required": "You must accept the terms and conditions as well as the privacy policy.",
        "username_required": "The username is required.",
        "username_invalid": "The username can only contain letters, numbers, spaces, underscores or hyphens.",
        "email_invalid": "The email is not valid.",
        "email_required": "The email is required.",
        "password_required": "The password is required.",
        "password_min": "The password must have 8 characters.",
        "password_repeat_required": "Please confirm your password.",
        "password_mismatch": "The passwords don't match.",
        "password_complexity": "Include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.",
        "createTitle": "Register Form",
        "name": "Name",
        "email": "Email",
        "password": "Password",
        "repeat_password": "Repeat Password",
        "password_error_title": "Password Error",
        "password_error_message": "The passwords do not match.",
        "account_create_title": "Account Successfully created",
        "account_create_message": "Please confirm your email address with the confirmation we sent.",
        "registration_error": "Registration Error",
        "register": "Register",
        "register_form": "Register Form",
        "forget_password": "Forget Password",
        "send": "Send",
        "loading": "Loading ...",
        "code": "Code",
        "new_password": "New Password",
        "resetPasswordTitleAlert": "Reset Password",
        "resetPasswordAlertMessage": "We just send you a mail to ",
        "error": "Error",
        "badEmail": "Please enter a valid email address.",
        "newPasswordTitleAlert": "Password Changed Accepted",
        "newPasswordAlertMessage": "You new password have been accepted",
        "login_form": "Login Form",
        "goToForgotPassword": "Forgot Password?",
        "EmailConfirmSuccessTitle": "Email Confirmation Succeed",
        "EmailConfirmSuccessMessage": "Welcome to your Schedulum tools.",
        "EmailConfirmErrorTitle": "Email Confirmation Error",
        "warning": "Warning",
        "enterEmail": "Please enter your email to get the confirmation code",
        "codeSended": "Confirmation Code Sended",
        "watchMailbox": "Please take a look in your mail box",
        "codeError": "Confirmation Code Error",
        "confirmEmail": "Confirm Email",
        "confirmEmailLink": "Go to email confirmation",
        "resendCode": "Resend Code",
        "confirmEmailForm": "Confirm Email",
        "type_title": "Invalid Type",
        "type_message": "Please select a type of user",
        "agree_to": "I agree to the",
        "terms_of_use": "Terms of Use",
        "privacy_policy": "Privacy Policy",
        "and": "and",
        "acceptedTermsTitle": "Terms & Conditions with Privacy Policy",
        "acceptedTermsMessage": "You must accept the terms and conditions as well as the privacy policy"
      },
      profile: {
        "deleteAccount": "Delete Account",
        "deleteMessage": "Warning no rollback will be possible...Are you sure you want to delete your account?",
        create_company: "Create Company",
        add_worker: "Add workers",
        linkedCompanyTitle: "Company Link",
        linkedCompany: "... You need to be linked to a Company ...",
        choose_plan: "Select a plan",
        choose_plan_MACOS: "Your company need to choose a plan",
        change_plan: "Change plan",
        shifts: "Shifts",
        "error_uploading_image": "Error to upload your Image",
        "warning": "Warning",
        "provideUsername": "Please provide a username",
        "fileTooLargeTitle": "File too large", 
        "fileTooLarge": "Please pick a file smaller than 5MB",
        "noWorkingHours": "No working hours at all",
        "10Hours": "10 working hours",
        "20Hours": "20 working hours",
        "30Hours": "30 working hours",
        "40Hours": "40 working hours",
        "50Hours": "50 working hours",
        "60Hours": "60 working hours",
        "70Hours": "70 working hours",
        "80Hours": "80 working hours",
        "90Hours": "90 working hours",
        "english": "English",
        "french": "French",
        "changePicture": "Change Profile Picture",
        "username": "Username",
        "firstname": "First Name",
        "lastname": "Last Name",
        "phoneNumber": "Phone Number",
        "preferences": "Preferences",
        "availabilities": "Availabilities",
        "night": "Nuit",
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday",
        "sunday": "Sunday",
        "submitting": "Submitting...",
        "submit": "Submit",
        "startPlaceholder": "Enter your ",
        "usernameRequired": "Username required",
        "usernameRequiredMessage": "Username should have more then 3 characters",
        "lastnameRequired": "Last Name is required",
        "lastnameRequiredMessage": "Last Name should have more then 3 characters",
        "firstnameRequired": "First Name is required",
        "firstnameRequiredMessage": "First Name should have more then 3 characters",
        "editProfile": "Edit Profile",
        "language": "Language",
        "becomeManager": "Promote Manager",
        "becomeEmployee": "Demote Employee",
        "promoteManager": "Do you really want to promote this employee to a manager?",
        "promoteEmployee": "Do you really want to demote this manager to a simple employee?",
        "suspendWorker": "Do you really want to suspend this employee?",
        "unsuspendWorker": "Do you really want to reactivate this employee?"
      },
      company: {
        "createTitle": "Create Company Account",
        "name": "Name",
        "email": "Email",
        "address": "Address",
        "phone": "Phone",
        "password": "Password",
        "repeat_password": "Repeat Password",
        "password_error_title": "Password Error",
        "password_error_message": "The passwords do not match.",
        "account_create_title": "Company Successfully created",
        "account_create_message": "Add employees and use tools Schedulum provide",
        "registration_error": "Registration Error",
        "register": "Register",
        "only_one_account_title": "Company already exist",
        "only_one_account_message": "You can only have 1 company by account",
        "startPlaceholder": "Enter the company ",
        "stopPlaceholder": "",
        "nameRequired": "Name required",
        "nameRequiredMessage": "Name should have more then 3 characters",
        "phoneNumberRequired": "Téléphone requis",
        "phoneNumberRequiredMessage": "Phone should have more then 7 characters",
        "addressRequired": "Address required",
        "addressRequiredMessage": "Address should have more then 3 characters",
        "phoneFormatError": "Phone number format must look like: 000-000-0000"
      },
      scheduler: {
        "day": "Day",
        "week": "Week",
        "month": "Month",
        "all_shifts": "All Shifts",
        "all_users": "All Users",
        "all_users_short": "All",
        deleteShiftTitle: "Delete Shift",
        deleteShiftMessage: "Are you sure you want to delete this shift?",
      },
      agenda: {
        "noShift": "No shift for this week.",
        "info": "Info",
        "infoTitle": "Information",
        "selectDate": "Select a date",
      },
      user: {
        "username": "Username",
        "email": "Email",
        "hours": "Hours",
        "night": "Night",
        "monday": "Monday",
        "tuesday": "Tuesday",
        "wednesday": "Wednesday",
        "thursday": "Thursday",
        "friday": "Friday",
        "saturday": "Saturday",
        "sunday": "Sunday",
        "isConfirmed": "Is Confirmed",
      },
      table: {
        "excel_title": "Paste the Excel table here :",
        "upload_excel_title": "Upload an Excel file :",
        "shift_create": "Shifts to create :",
        "open_shift_create": "Open shifts to create :",
        "shift_example": "Shifts example :",
        "open_shift_example": "Open shifts example ( PUBLIC ) :",
        "shift_tip": "We will ignore the first row of the table you will paste ( COLUMN TITLES ROW )",
        "users_list": "Users List",
        "placeholder": "Paste here with Ctrl+V",
        "upload_box1": "Drag & drop a file here or ",
        "upload_box2": "click to select",
      },
      braintree: {
        pay: "Pay",
        locale: "en_US",
        "paymentSuccessTitle": "Payment Success",
        "paymentSuccessMessage": "Payment has been successfully processed",
        "noPaymentTitle": "Payment Failure",
        "noPaymentMessage": "Payment has not been processed correctly",
      },
      stripe: {
        locale: "en",
        successTitle: "Schedulum Payment Success",
        successMessage: "Payment has been successfully processed",
        stripeCancelScreen: "Stripe Cancel Screen", 
        stripeSuccessScreen: "Stripe Success Screen",
        free: {
          title: "Free Plan",
          promoCode: "Promotional code", 
          create: "Try our free plan",
          atleast_one_character: "You might enter a promotional code.",
          alreadyComId: "Your account is already linked to a company",
          freeError: "Free Plan Error",
        },
        trial: {
          description: "With a 30 days free trial."
        },
        starter: {
          name: "Starter Subscription",
          description: "Get access to all features. Subscription for 10 workers maximum.",
          price: "15,00$ / month",
        },
        essential: {
          name: "Essential Subscription",
          description: "Get access to all features. Subscription for 20 workers maximum.",
          price: "30,00$ / month",
        },
        plus: {
          name: "Plus Subscription",
          description: "Get access to all features. Subscription for 30 workers maximum.",
          price: "45,00$ / month",
        },
        advanced: {
          name: "Advanced Subscription",
          description: "Get access to all features. Subscription for 40 workers maximum.",
          price: "60,00$ / month",
        },
        pro: {
          name: "Pro Subscription",
          description: "Get access to all features. Subscription for 50 workers maximum.",
          price: "75,00$ / month",
        },
        business: {
          name: "Business Subscription",
          description: "Get access to all features. Subscription for 80 workers maximum.",
          price: "120,00$ / month",
        },
        premium: {
          name: "Premium Subscription",
          description: "Get access to all features. Subscription for 100 workers maximum.",
          price: "150,00$ / month",
        },
        elite: {
          name: "Elite Subscription",
          description: "Get access to all features. Subscription for 150 workers maximum.",
          price: "225,00$ / month",
        },
        ultimate: {
          name: "Ultimate Subscription",
          description: "Get access to all features. Subscription for 200 workers maximum.",
          price: "300,00$ / month",
        },
        infinity: {
          name: "Infinity Subscription",
          description: "Get access to all features. Subscription for inlimited workers maximum.",
          price: "450,00$ / month",
        },
        subscribing: "Subscribing",
      },
      worker: {
        "email_invalid": "Invalid Email",
        "email_required": "Email Is Required",
        "create_title": "Create Workers",
        "create_message": "Workers has been created successfully",
        "create_error": "Worker Creation Error",
        "delete_error": "Worker Delete Error",
        "delete_error_message": "This Worker account is linked with your company",
        "create_no_new_worker": "No New Worker Have Been Created",
        "workers_list_title": "Workers List",
        addWorkerForm: "Add Workers Form",
        coworkers: "Coworkers",
        writeSearch: "Search Coworkers",
        create_max_10_workers: "You cannot create more than 10 workers with this plan",
        create_max_20_workers: "You cannot create more than 20 workers with this plan",
        create_max_30_workers: "You cannot create more than 30 workers with this plan",
        create_max_40_workers: "You cannot create more than 40 workers with this plan",
        create_max_50_workers: "You cannot create more than 50 workers with this plan",
        create_max_80_workers: "You cannot create more than 80 workers with this plan",
        create_max_100_workers: "You cannot create more than 100 workers with this plan",
        create_max_150_workers: "You cannot create more than 150 workers with this plan",
        create_max_200_workers: "You cannot create more than 200 workers with this plan",
        atleast_one_email: "You must enter at least one worker email",
      },
      shift: {
        title: 'Title: ',
        role: "Role: ",
        location: "Location: ",
        information: "Information: ",
        startAt: "Start at: ",
        stopAt: "Stop at: ",
        dragUpdateTitle: "Do you want to update this Shift?",
        dragUpdateStartAt: "Job will start at: ",
        dragUpdateStopAt: "Job will stop at: ",
        deleteTitle: "Do you want to delete this Shift?",
        deleteMessage: "After deleting this shift it will be lost forever",
        areYouSure: "Are you sure?",
        acceptedMessage: "Do you really want to accept this shift?",
        deletedMessage: "Do you really want to delete this shift?",
        confirmedMessage: "Do you really want to confirm this shift?",
        unconfirmedMessage: "Do you really want to unconfirm this shift?",
        awaitingConfirmation: "...Awaiting Confirmation",
        accepted: "Accepted",
        notAccepted: "Not Accepted",
        confirmed: "Comfirmed",
        confirm: "Confirm",
        unconfirm: "Unconfirm",
        accept: "Accept",
        worker: "Worker: ",
        update: "Update",
        cancel: "Cancel",
        delete: "Delete",
        create: "Create",
        save: "Save",
        showDetails: " ... Show Details ... ",
        new: "New",
        select: "-- Select --",
        goTo: "Go to shift",
        "quality": "Quality",
        "performance": "Performance",
        "punctuality": "Punctuality",
        "rate": "Rate",
        "honor": "Reward",
        "distance_km": "Km",
        "star": "star(s)",
        "rankShiftTitle": "Evaluate Shift",
        "formSubmit": "Your Assessment",
        "formHonorSubmit": "Your Reward",
        "rankUpdate": "Update",
        "saveRank": "Save Assessment",
        "honorShiftTitle": "Rewarding Employee",
        "errorAcceptingShift": "Error accepting shift",
        "publicRadio": "Select For Public Send",
        "roundMedal": "Medal of Endurance and Punctuality",
        "starMedal": "The star of attendance and safety",
        "trophy": "Bowl of Excellence and Performance",
        "trophy2": "Trophy of the Month Employee",
        "noGeolocation": "Your location did'nt provide any Geolocalisation",
        "ai_rec_button": "AI Recommendation",
        "AIrecError": "AI are trained every month, please wait",
        "addressLocationTitle": "Address Suggestion",
        "addressLocationMessage": "Do you want to change your location for the suggested location: ",
        "addressLocationMessage1": "Current Location: ",
        "addressLocationMessage2": "Suggested Location: ",
        "addressLocationUSE": "Use Suggested Location",
        "addressLocationKEEP": "Keep Current Location",
        "addressNotFoundTitle": "Address not found",
        "addressNotFoundMessage": "We did'nt recognize the address location, do you want to modify it ?",
        "addressNotFoundContinue": "Continue Without Modification",
        "addressNotFoundModify": "Modify Location",
        "geoFoundTitle": "Geolocalisation Found",
        "geoFoundMessage": "GEOLOCALISATION IS VERY USEFULL FOR AI SUGGESTIONS!",
        "geoFoundMessage1": "Do you want to use the geolocalisation coordinates we found for the suggested location ?",
        "geoFoundLatitude": "Latitude: ",
        "geoFoundLongitude": "Longitude: ",
        "geoFoundDONT": "Don't Use Coordinates",
        "geoFoundUSE": "Use New Coordinates",
        "getGeoData": "Get Geolocation",
        "publicCheckbox": "Public",
        "errorGeo": "Please enter a location",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "moreUserTitle": "More Users",
        "seeMoreUsers": "If you want to see more users you need to use pagination",
        "previousUser": "Previous Users",
        "nextUser": "Next Users",
      },
      punch: {
        "at": "Clocked in at: ",
        "location": "Clocked in location",
        "close": "Close",
        "details": "Clocked in details",
        "punchSaveTitle": "Clock in saved",
        "punchSaveErrorTitle": "Clock in error",
        "punchSaveMessage": "Thank you, your clock in has been saved",
        "punchSaveErrorMessage": "Your clock in has not been saved, make sure you authorized geolocation",
      },
      post: {
        areYouSure: "Are you sure?",
        deleteMessage: "Do you really want to delete this post",
        writeComment: "Write your comment",
        pleaseWriteComment: "Write to your team",
        pleaseWriteCommentCoWorker: "Write to your coworker",
        submit: "Submit",
        delete: "Delete",
        createdAt: "Created at: ",
        "deletedMessage": "Do you really want to delete this post?",
        "deleteOrChangeTitle": "Delete or Change Image",
        "deleteOrChangeMessage": "Do you want to delete or change this image?",
        "imageChange": "Change Image",
        "imageDelete": "Remove Image"
      },
      document: {
        areYouSure: "Are you sure?",
        deleteMessage: "Do you really want to delete this document",
        importFileBtn: "Import File",
        selectFile: "Select File",
        sizeTitle: "Your file exceeds the limit",
        sizeMessage: "Your file must not exceed 5MB",
      },
      billing: {
        pick_subscription: "Select a subscription",
        subscription: "Subscription for a maximum of ",
        workers: " workers",
        price: "Price: $",
        by_mount: " / month",
      },
      detail: {
        title: "Scheduler Details",
        rhTitle: "Ahead of planning",
        rhMessage: "Master work planning and time tracking with an all-in-one, intuitive, and powerful solution. Our application allows you to structure your teams daily routines with unparalleled efficiency.",
        rhSpreadsheetTitle: "Use our simplifiy shifts creation",
        rhSpreadsheetMessage: "<p>Upload your shifts via spreadsheet files, such as Microsoft Excel, LibreOffice Spreadsheet, or simply a simple CSV file. Just use the correct layout and you're good to go.</p><p>You can also paste a copy of a few lines rather than uploading a full file, or use the application's methods to create shifts from scratch.</p>",
        rhGPSTitle: "Track working hours accurately",
        rhGPSMessage: "<p>With our time clock system, your employees can easily record their hours, with GPS tracking to ensure reliable field attendance tracking.</p><p>With our time clock system, your employees can easily record their hours, with GPS tracking to ensure reliable field attendance tracking.</p>",
        timeTitle: "Smart Workforce Scheduling",
        timeMessage: "Efficiently plan your employees’ schedules and tasks. Our application enables HR managers to organize work in a structured and intuitive way. With a centralized planning system, you can assign shifts, track tasks, and get a real-time overview of your company’s activity. The generated statistics provide clear insights into productivity, performance, and internal organization, making it easier to make informed decisions and optimize operations.",
        statTitle: "See performance at a glance",
        statMessage: "Track hours worked, absences, lateness, and overtime with clear graphs and real-time statistics. Identify trends at a glance and optimize your team's organization. Gain visibility, easily adjust schedules, and base your decisions on concrete data, accessible directly from the application.",
        heatmapTitle: "Heatmap for Employee Strengths Analysis",
        heatmapMessage: "<p>The heatmap is a powerful visual tool for quickly displaying the quality, performance, punctuality, and satisfaction of employees during their shifts.</p><p>Color variations make it easy to identify at a glance the strengths and weaknesses of teams or specific employees. The heatmap helps managers immediately target areas for improvement without having to wade through complex tables of numbers.</p><p>It highlights trends by user or time period, making it easier to analyze successful shifts and areas for improvement. By visualizing positive contributions (green areas), companies can highlight the right people, strengthen engagement, and establish a culture of continuous improvement.</p>",
        recommendationTitle: "Smart recommendations for your work shifts",
        recommendationMessage: "<p>You can now benefit from artificial intelligence-based recommendations to select the best employees for your work shifts.</p><p>This AI is updated monthly. Its recommendations and predictions become more accurate over time as you assign and evaluate your employees' shifts.</p><p>This artificial intelligence takes several key criteria into account:</p><ul><li style='padding-bottom: 15px;'>Individual availability of employees (days and shifts previously worked)</li><li style='padding-bottom: 15px;'>Historical clock-in locations (geographical presence, consistency, mobility)</li><li style='padding-bottom: 15px;'>Performance evaluations you have given for previous shifts</li><li style='padding-bottom: 15px;'>Distinctions and recognitions you have awarded them (e.g., employee of the month, special mentions, etc.)</li></ul><p>Based on this data, the AI can automatically suggest the most suitable profiles for each open shift — taking into account performance, reliability, and scheduling compatibility.</p>",
        boxplotTitle: "Track working hours accurately",
        boxplotMessage: "<p>The boxplot is a very useful visual statistical tool for analyzing the distribution and variability of indicators such as quality, performance, punctuality, and shift satisfaction.</p><p>The boxplot easily shows how scores vary for each indicator: median, quartiles, and extreme values. This allows for the rapid detection of abnormal or recurring deviations. Isolated points above or below the box indicate unusual shifts (very good or very poor), allowing for the investigation of specific cases.</p><p>By displaying the quality, performance, punctuality, and rate boxplots side by side, companies can immediately visualize which aspect is the most stable or variable over time or by user. With these visual insights, managers can target the most volatile indicators and define targeted improvement plans for their teams.</p>",
        barplotTitle: "The bar chart compares the average values",
        barplotMessage: "<p>The bar chart is a simple and visual tool for comparing average or overall values ​​across various performance indicators, such as quality, performance, punctuality, and shift satisfaction.</p><p>The boxplot easily shows how scores vary for each indicator: median, quartiles, and extreme values. This allows for the rapid detection of abnormal or recurring deviations. Isolated points above or below the box indicate unusual shifts (very good or very poor), allowing for the investigation of specific cases.</p><p>A bar plot allows you to see at a glance how key indicators rank on a scale of 0 to 5. It makes it easy to understand which criteria are rated highest (e.g., quality) and which require more attention. By plotting the average values ​​for quality, performance, punctuality, and rate side by side, the bar plot facilitates a direct comparison of overall strengths and weaknesses.</p><p>If performance or punctuality lags behind other indicators, the company can prioritize targeted corrective actions for these specific areas. The bar chart is an excellent visual aid for boardroom presentations because it synthesizes complex information in an immediate and accessible manner.</p>",
        spyderradarTitle: "The radar chart displays multiple indicators simultaneously.",
        spyderradarMessage: "<p>The radar chart is a powerful visualization tool that allows you to simultaneously display multiple indicators in a spiderweb format. For your clients, this tool provides a comprehensive and comparative overview of shifts in criteria such as quality, performance, punctuality, and satisfaction rate.</p><p>Unlike separate bars or curves, the radar chart displays all indicators simultaneously on a single pie chart. This allows you to immediately see if a profile is \"balanced\" or if there are weak or strong areas. The differences between the different branches of the radar allow you to quickly identify priority areas for improvement (e.g., punctuality is lagging behind quality).</p><p>Overlapping multiple radars (by user or by period) allows you to easily compare individual performance or changes over time. The radar chart is highly visual and popular in meetings because it simplifies the reading of complex indicators, even for non-data experts.</p>",
        communicationTitle: "Strengthen Internal Communication",
        communicationMessage: "Enhance collaboration across your teams with our integrated system for chat, internal news sharing, and automated notifications. Whether it's sharing updates, coordinating tasks, or quickly informing your employees, our platform ensures smooth, centralized, and effective communication. Keep everyone informed, engaged, and aligned—wherever they are.",
        comPostTitle: "Communicate in real time",
        comPostMessage: "<p>Chat instantly with your colleagues using our integrated messaging. Whether you're chatting privately or in a group, you stay connected at all times, without having to use external tools. Conversations are organized, secure, and always accessible from the app.</p><p>This feature promotes responsiveness and coordination between team members, particularly for schedule changes, emergencies, or important announcements. No more waiting for an email or making a call: information flows quickly and in the right context. Stay aligned, even remotely, and strengthen collaboration every day.</p>",
        comLeaveTitle: "Manage your leave without friction",
        comLeaveMessage: "<p>With our app, requesting leave is quick and easy. In just a few clicks, submit your desired dates, add a comment if necessary, and track the status of your request in real time. No more paper forms or back-and-forth emails: everything is centralized and automated.</p><p>Managers receive instant notifications and can approve or reject requests in a snap. The calendar is automatically updated, allowing the entire team to view upcoming absences and better plan work schedules. The result: fewer errors, greater clarity, and smoother leave management for everyone.</p>",
        comSwapTitle: "Share your shifts easily",
        comSwapMessage: "<p>Transfer a shift to a colleague in just a few clicks. Select the shift, choose the available person, and the request is sent. Once accepted, the schedule is automatically updated, without errors or confusion.</p><p>This feature simplifies communication between colleagues, improves responsiveness to unforeseen events, and reduces the stress of last-minute changes. It offers flexible and efficient management while maintaining a clear and fluid organization. Stay connected, flexible, and in sync with your team.</p>",      
      },
      request: {
        swapMessage: "Would you really want to transfer this shift to ",
        leaveMessage: "Would you really want to send this leave request?",
        transfer: "Transfer",
        submitRequest: "Submit Transfer Request",
        transferSwapTitleForm: "Transfer Form",
        transferLeaveTitleForm: "Leave Request Form",
        start: "Start date",
        stop: "End date",
        createLeave: "Ask Leave request",
        transferTo: "Transfer to:",
        request_error: "Request Error",
        transfered: "Transfered",
        alreadySwaped: "This transfer request has been completed",
        transfer_awaiting: "Transfer awaiting ...",
        chooseTitle: "Select Request type",
        chooseMessage: "You can send and get your leave request or watch your shift to transfer",
        swapLink: "Shift Transfer",
        askLink: "Leave requests",
        swapManagerLink: "Shift Transfer Management",
        askManagerLink: "Leave Requests Management",
        noRequest: "No request available",
        giveTab: "Shifts you send",
        receiveTab: "Shifts avalaible",
        managerTab: "Transfer (MANAGER)",
        leaveTab: "Leave asked",
        createLeaveTab: "Create leave request",
        managerLeaveTab: "Leave requests (MANAGER)",
        ask: "Ask",
        acceptMessage: "Do you really want to accept the leave request?",
        deleteMessage: "Do you really want to delete the leave request?",
      },
      suspended: {
        accountSuspended: "Your account has been suspended",
        contactCompany: "Contact your company to solve the problem",
        tryAgain: "Try Again",
        noCompany: "No Company's found",
        noAccountTitle: "No Subscription Found",
        noAccount: "Your company need to subscribe to a plan"
      },
      blog: {
        searchPlaceholder: "Search posts...",
      },
      toast: {
        welcome: "Welcome ",
        companyNeeded: "You have to register a company",
        shiftCreated: "Your shift has been successfully created",
        shiftUpdated: "Your shift has been successfully updated",
        shiftDeleted: "Your shift has been successfully deleted",
        openShiftCreated: "Your public shift has been successfully created",
        openShiftDeleted: "Your public shift has been successfully deleted",
        openShiftUpdated: "Your public shift has been successfully updated",
        confirmEmail: "Your account has been successfully created",
        confirmEmailTitle: "Please confirm your email",
        firstConnect: "Your email has been confirmed",
        firstConnectTitle: "Log in to your account",
        editProfile: "Your profile has been successfully updated",
        editCompany: "Your compny has been successfully updated",
        leaveCreated: "Your leave request has been successfully created",
        leaveAccepted: "A leave request has been successfully accepted",
        leaveDeleted: "A leave request has been successfully deleted",
        swapCreated: "Your shift swap request has been successfully created",
        swapAccepted: "A shift swap request has been successfully accepted",
        swapDeleted: "A shift swap request has been successfully deleted",
        companyRestrictedTitle: "Limited Acces Area",
        companyRestricted: "This area has restricted acces"
      },
      help: {
        title: "Video Examples",
        moreTitle: "More Options",
        helpTitle: "Help List",
        shiftCreate: "Shift Create",
        openShiftCreate: "Open Shift (PUBLIC) Create",
        pasteSpreadsheet: "Paste Shifts From A Spreadsheet",
        uploadSpreadsheet: "Upload Shifts From A spreadsheet",
        editShift: "Edit And Transfer Shift",
        transferShift: "Transfer Shift",
        deleteShift: "Delete Shift",
        clockIn: "Clock In On A Shift",
        uploadDocument: "Upload Document",
        leaveRequest: "Ask A Leave Request",
        shiftTitle: "How to create or delete shifts",
        shiftMessage: "Here are examples for creating shifts or open shifts (PUBLIC). You can create one shift at a time, or create multiple shifts using a spreadsheet. There's also an example for deleting a shift and videos demonstrating how to modify or transfer a shift to another employee.",
        miscTitle: "How to use many options",
        miscMessage: "Here are examples of different options. You'll learn how to clock in and out for your shift. You'll find an example of how to send a document to an employee, as well as a video demonstrating how to request time off.",
      },
      ai_chatbox: {
        title_box: "Online AI Assistant",
        placeholder_box: "Chat with AI while browsing the site.",
        placeholder: "Hello! How can I help you today?",
        llm_error: "Error communicating with the LLM:",
        error: "Sorry, an error occurred while communicating with the server.",
        input_placeholder: "Type your message...",
        send: "Send",
        confirm_clear: "Are you sure you want to clear the chat history?",
        clear_history: "Clear AI Chat History",
        clear: "Clear",
      }
    },
  },
  fr: {
    translation: {
      meta: {
        description: "Optimisez la gestion de votre personnel avec notre logiciel intuitif Schedulum. Créez vos plannings, gérez les shifts et les absences en quelques clics. Essayez gratuitement.",
        descriptionNews: "Découvrez les dernières actualités de Schedulum : nouvelles fonctionnalités, mises à jour produit, astuces pour la gestion des horaires et la planification des équipes pour PME.",
        descriptionHelp: "Obtenez de l'aide pour Schedulum : consultez les fonctionnalités, les mises à jour produit, ainsi que les meilleurs principes de gestion des horaires et de planification d'équipe pour PME.",
        descriptionDetails: "Tous les détails sur le logiciel Schedulum: fonctionnalités, mises à jour produit, astuces pour la gestion des horaires et la planification des équipes pour PME.",
        descriptionSignUp: "Inscrivez-vous pour utiliser le logiciel Schedulum : fonctionnalités, mises à jour du produit, conseils pour la gestion des plannings et la planification d'équipe pour les PME.",
        descriptionConfirmEmail: "Confirmez votre adresse e-mail pour utiliser votre compte sur Schedulum : fonctionnalités, mises à jour du produit, conseils pour la gestion des plannings et la planification d'équipe pour les PME.",
        ogTitle: "Logiciel de planification des horaires pour PME | Schedulum",
        ogTitleNews: "Actualités sur le logiciel de planification des horaires pour PME | Schedulum",
        ogTitleHelp: "Aides sur le logiciel de planification des horaires pour PME | Schedulum",
        ogTitleDetails: "Détails sur le logiciel de planification des horaires pour PME | Schedulum",
        ogTitleSignUp: "Formulaire d'inscription | Schedulum ",
        ogTitleConfirmEmail: "Fourmulaire de confirmation de courriel | Schedulum",
        ogDescription: "Gagnez du temps sur la gestion de vos plannings, absences et communication d'équipe. Essai gratuit de 30 jours.",
        ogDescriptionNews: "Toutes les informations essentielles sur Schedulum : sorties de fonctionnalités, conseils de planification, et annonces importantes pour les PME.",
        ogDescriptionHelp: "Toutes l'aides essentielles sur Schedulum : sorties de fonctionnalités, conseils de planification, et annonces importantes pour les PME.",
        ogDescriptionDetails: "Tout les détails intéressant sur Schedulum : sorties de fonctionnalités, conseils de planification, et annonces importantes pour les PME.",
        ogDescriptionSignUp: "Inscrivez-vous pour utiliser les services de Schedulum",
        ogDescriptionConfirmEmail: "Confirmation par e-mail de votre compte Schedulum",
        ogType: "website",
        ogTypeNews: "website",
        ogTypeHelp: "website",
        ogTypeDetails: "website",
        ogTypeSignUp: "website",
        ogTypeConfirmEmail: "website",
        ogUrl: "https://schedulum.org",
        ogUrlNews: "https://schedulum.org/actualites",
        ogUrlHelp: "https://schedulum.org/aide",
        ogUrlDetails: "https://schedulum.org/details",
        ogUrlSignUp: "https://www.schedulum.org/inscription",
        ogUrlConfirmEmail: "https://www.schedulum.org/confirmationZourriel",
        ogImage: "https://schedulum.org/SEO/homepage_fr.png",
        ogImageNews: "https://schedulum.org/SEO/actualites.png",
        ogImageHelp: "https://schedulum.org/SEO/aide.png",
        ogImageDetails: "https://schedulum.org/SEO/details_fr.png",
        ogImageSignUp: "https://schedulum.org/SEO/inscription.png",
        ogImageConfirmEmail: "https://schedulum.org/SEO/confirmationCourriel.png",
        markupName: "Schedulum - Planification des horaires d'employés et les RH",
        markupNameNews: "Schedulum - Actualités sur la planification des horaires des employés et les RH",
        markupNameHelp: "Schedulum - Aide sur la planification des horaires des employés et les RH",
        markupNameDetails: "Schedulum - Détails sur la planification des horaires des employés et les RH",
        markupNameSignUp: "Schedulum - Inscription pour la planification des horaires des employés et les RH",
        markupNameConfirmEmail: "Schedulum - Confirmation de courriel pour votre compte utilisant la planification des horaires des employés et les RH",
        markupDescription: "Logiciel de planification et de gestion des horaires d'employés, des absences et du pointage mobile (horloge de travail) pour les PME.",
        markupDescriptionNews: "Actualités sur le logiciel de planification et de gestion des horaires des employés, des absences et du pointage mobile (horloge de travail) pour les PME.",
        markupDescriptionHelp: "Aide sur le logiciel de planification et de gestion des horaires des employés, des absences et du pointage mobile (horloge de travail) pour les PME.",
        markupDescriptionDetails: "Détails sur le logiciel de planification et de gestion des horaires des employés, des absences et du pointage mobile (horloge de travail) pour les PME.",
        markupDescriptionSignUp: "Inscription sur le logiciel de planification et de gestion des horaires des employés, des absences et du pointage mobile (horloge de travail) pour les PME.",
        markupDescriptionConfirmEmail: "Confirmation de courriel pour l'utilisation de votre compte sur le logiciel de planification et de gestion des horaires des employés, des absences et du pointage mobile (horloge de travail) pour les PME.",
      },
      image: {
        team_work: "Travail d'équipe",
        hr_team: "Les resources humaines",
        prod_eff: "Production et efficacité",
        dashboard_mobile: "Application mobile",
        agenda_manager: "Gestion d'agenda",
        sidebar_option: "Options et paramètres",
        gmaps: "Positionement GPS",
        posts: "Messagerie",
        scheduler: "Planificateur",
        punch_gps: "Pointage à l'arrivée et au départ avec coordonnées GPS",
        upload_table: "Téléchargement de tableau de quarts de travail",
        agenda: "Agenda",
        request: "Demande de requêtes",
        leave: "Demande de congé",
        desktop: "Tableau de bord",
        document: "Documents",
        swap: "Transfert de quarts",
        boxplot: "Graphique de boîte",
        barplot: "Graphique de barre",
        heatmap: "Carte par zone de chaleur",
        ai_recommendation: "Recommendation de l'IA",
        spyder_radar: "Radar espion",
        com_posts: "Système de messagerie",
        com_leave_requests: "Système de demande de congé",
        com_swap_requests: "Système de transfert de quart",
        appStore: "Téléchargée l'application sur App Store",
        gplay: "Téléchargée l'application sur Google Play",
      },
      link: {
        dashboard: "/tableau_de_bord",
        news: "/actualites",
        user: "/utilisateur",
        users: "/utilisateurs",
        help: "/aide",
        signin: "/connection",
        signup: "/inscription",
        posts: "/messages",
        shifts: "/quarts",
        shift: "/quart",
        open_shifts: "/quarts_publics",
        scheduler: "/planificateur",
        settings: "/parametres",
        swap_create: "/requetes/transferts/creation/quart/",
        suggested_requests_swap: "/utilisateurSuggere/requetes/transferts",
        requests_swap: "/requetes/transferts",
        requests_leave: "/requetes/conges",
        leave_create: "/requetes/conge/creation",
        swap_management: "/requetes/gestion/transferts",
        leave_management: "/requetes/gestion/conges",
        agenda_management: "/agenda/gestion",
        add_worker: "/ajouter/travailleurs",
        billing: "/facturation",
        company: '/compagnie',
        create_company: '/creation/compagnie',
        table_shift: "/table/quart",
        excel_shift: "/importation_excel/quart",
        table_open_shift: "/table/quart_public",
        excel_open_shift: "/importation_excel/quart_public",
        map: "/carte/",
        worker: "/travailleur",
        edit: "modification",
        coworkers: "collegues",
        management: "gestion",

      },
      title: {
        dashboard: "Profile",
        home: "Logiciel de planification des horaires | Gestion des horaires des employés | Schedulum",
        blog: "Actualité du Logiciel de planification des horaires | Actualité de la Gestion des horaires des employés | Schedulum",
        help: "Aide sur le Logiciel de planification des horaires | Aide sur la Gestion des horaires des employés | Schedulum",
        details: "Détails sur le Logiciel de planification des horaires | Détails sur la Gestion des horaires des employés | Schedulum",
        scheduler: "Logiciel planificateur d'horaires | Gestion des horaires des employés",
        agenda: "Logiciel de planification d'Agenda | Gestion des agenda d'employés",
        management: "Logiciel de Gestion d'Agenda | Gestion des agenda d'employés",
        billing: "Facturation",
        signin: "Connection de planificateur",
        signout: "Déconection du Planificateur",
        signup: "Inscription | Schedulum",
        forgotPassword: "Password Oublié | Schedulum",
        newPassword: "Nouveau Password | Schedulum",
        confirmEmail: "Confirmation De Courriel | Schedulum",
        createCompany: "Création d'Entreprise | Schedulum",
        addWorkers: "Ajouter Des Travailleurs | Schedulum",
        userShift: " Quarts",
        shift: "Quart",
        shifts: "Quarts De Travails",
        openshifts: "Quarts De Travails Ouverts",
        spreadsheet: "Envoyer Tableur | Schedulum",
        table: "Coller Une Table",
        users: "Utilisateurs",
        user: "Utilisateur",
        swap_requests: "Requêtes de Transfert",
        leave_requests: "Requêtes de Congé",
        request: "Requête",
        terms: "Conditions d'Utilisation | Schedulum",
      },
      error: {
        "goHome": "Retourner à la page d'accueil",
        "users_required": "Utilisateur requis",
        "dates_required": "Dates requises",
        "role_required": "Role requis",
        "info_required": "Info requis",
        "location_required": "Location requis",
      },
      dashboard: {
        "linkedCompanyTitle": "Company Link Missing",
        "linkedCompany": "You need to be linked to a Company",
      },
      navBar: {
        "language": "Langage",
        "help": "Aide",
        "tools": "Outils",
        "users": "Utilisateurs",
        "dashboard": "Tableau de bord",
        "news": "Actualité",
        "table": "Coller une Table",
        "spreadsheet": "Envoyer Tableur",
        "scheduler": "Planificateur",
        "agenda": "Agenda",
        "agendaManager": "Gestion d'Agenda",
        "email": "Courriel",
        "password": "Mot de Passe",
        "login": "Connection",
        "signup": "Inscription",
        "signout": "Déconnection",
        "shift": "Quart",
        "open_shift": "Quart Ouvert",
        "settings": "Paramètres",
        "documents": "Gestion De Documents",
        "myDocuments": "Documents",
        "shifts": "Quarts",
        "open_shifts": "Quarts Ouverts",
        "posts": "Messages",
        "request": "Requêtes",
        "suspendUser": "Suspendre le travailleur",
        "unsuspendUser": "Réactivez le travailleur"
      },
      home: {
        "title": "La meilleure application pour l'affectation et la planification des quarts de travail",
        "subtitle1": "Simplifiez la gestion de votre personnel avec un planning intuitif",
        "subtitle1_message1": "Fatigué de jongler entre feuilles de calcul, appels téléphoniques et demandes de dernière minute pour élaborer les plannings de votre équipe ? Ne perdez plus de temps et d'énergie avec un processus complexe. Schedulum est la solution intuitive conçue pour simplifier vos tâches RH au quotidien.",
        "subtitle1_message2": "Notre application vous offre un contrôle total sur vos plannings : créez-les et partagez-les avec vos employés en quelques clics. Finis les problèmes de communication et les confusions ! Votre équipe peut consulter ses plannings en temps réel, demander des congés et échanger des horaires avec ses collègues, le tout depuis une plateforme unique et intuitive.",
        "subtitle1_message3": "En automatisant votre planification, Schedulum vous permet de vous concentrer sur l'essentiel : la croissance de votre entreprise. Réduisez les erreurs administratives, améliorez la communication au sein de votre équipe et gagnez en productivité.",
        "subtitle1_message4": "Prenez le contrôle de vos horaires et libérez votre temps pour de bon.",
        "subtitle2": "Découvrez les fonctionnalités clés de notre logiciel de planification d'horaires",
        "subtitle2_message1": "Vous cherchez à transformer la gestion de vos équipes ? Notre application est bien plus qu'un simple calendrier. Elle est un véritable atout pour votre productivité et la satisfaction de vos employés. Découvrez les fonctionnalités qui font la différence :",
        "subtitle2_message2": "Planification Intelligente et Rapide : Créez des plannings d'équipes en quelques minutes, et non plus en quelques heures. Notre interface intuitive vous permet de visualiser les disponibilités, les congés et les qualifications en un coup d'œil, pour une assignation optimale.",
        "subtitle2_message3": "Communication Centralisée : Fini les appels et les messages qui se perdent. Notre application intègre un système de communication interne pour que les employés puissent échanger entre eux et avec leur gestionnaire. Les notifications automatiques garantissent que tout le monde est informé des mises à jour en temps réel.",
        "subtitle2_message4": "Gestion des Ressources Humaines : Centralisez les informations de votre personnel, suivez les heures de travail et exportez les données de paie en toute simplicité. Ces fonctionnalités automatisées réduisent les erreurs administratives et vous font gagner un temps précieux.",
        "subtitle2_message5": "Analyses de Performance : Prenez des décisions éclairées grâce à des tableaux de bord analytiques. Obtenez une vue d'ensemble des heures travaillées, des coûts de main-d'œuvre et de la productivité.",
        "subtitle2_message6": "Avec notre service, vous ne gérez pas seulement des horaires, vous optimisez vos opérations.",
        "subtitle3": "Comment notre logiciel aide les PME",
        "subtitle3_message1": "Les petites et moyennes entreprises (PME) font face à un défi unique : maximiser leur productivité sans avoir les ressources des grandes sociétés. Notre logiciel est conçu spécifiquement pour vous. Il vous aide à surmonter les obstacles du quotidien et à concentrer votre énergie sur la croissance de votre entreprise.",
        "subtitle3_message2": "Résolvez les problèmes de planification",
        "subtitle3_message3": "Le temps, c'est de l'argent. Chaque minute passée à jongler avec des tableaux Excel et des messages pour la planification de vos équipes est une minute perdue. Notre solution vous permet de créer et de gérer des horaires en quelques minutes. Vous gagnez en efficacité et en précision, ce qui réduit les erreurs de paie et les conflits d'horaires.",
        "subtitle3_message4": "Réduction des erreurs : Le logiciel de planification détecte automatiquement les conflits d'horaires et les chevauchements pour éviter les erreurs avant même que le planning ne soit publié.",
        "subtitle3_message5": "Temps de travail optimisé : Notre système vous donne un aperçu clair des heures travaillées, des congés, et de la disponibilité des employés, ce qui vous aide à prendre des décisions de staffing plus intelligentes.",
        "subtitle3_message6": "Améliorez la communication interne",
        "subtitle3_message7": "Une bonne communication est le moteur d'une équipe efficace. Notre logiciel centralise toutes les communications liées aux horaires, ce qui élimine le besoin d'utiliser plusieurs plateformes de messagerie.",
        "subtitle3_message8": "Notifications instantanées : Informez vos employés des changements de quart en temps réel via des notifications directes.",
        "subtitle3_message9": "Échanges simplifiés : Vos employés peuvent demander des échanges de quarts ou des congés directement depuis l'application, rendant le processus transparent et facile à gérer pour tout le monde.",
        "subtitle3_message10": "En fin de compte, notre logiciel ne gère pas seulement des horaires, il vous donne le contrôle de vos opérations et vous permet de créer un environnement de travail plus productif et harmonieux.",
        "linkedCompany": "... Vous devez être associé à une entrerpise ...",
        "noShiftAvail": "Aucun Quart présentement disponible",
        "manageShift": " Gestion De Quarts ",
        "upcomingShift": " Quarts À Venir ",
        "manageOpenShift": " Gestion De Quarts Ouvert ",
        "openShiftAvail": " Quarts Ouverts Disponible ",
        "openPublicShiftAvail": " Quarts Ouverts Publics Disponible ",
        "openShift": " Quarts Ouverts ",
        "scheduler": "Planificateur",
        "shiftReceived": " Quarts Reçus ", 
        "newsFeed": " Fil d'Actualité ",
        "currentShift": "Quart Actuel",
        "startAt": "Débute à:  ",
        "stopAt": "Termine à:  ",
        "uploadDocTitle": "Documents",
        "uploadDoc": "Voulez vous télécharger des documents?",
        "goToDoc": "Vos documents",
        "goToDocManager": "Gestion de Documents",
        "notWorkingTitle": "Vous ne travailler pas présentement",
        "notWorking": "Merci de pointer quand vous voulez commencer ou terminer votre quart de travails",
        "shiftToFarTitle": "Votre quart ne commence pas tout de suite",
        "shiftToFar": "Vous devez commencer votre quart de travails moins de 30 minute avant le temps schédulé",
        "wantToPunchTitle": "Voulez-vous Pointer?",
        "wantToPunch": "Êtes-vous certain de vouloir pointer présentement?",
        "beenSuspended": "Vous avez été suspendu",
        "apply": "Continuer",
        "no_shift": "Aucun quart à venir",
        "safariNotificationTitle": "Gérer les Notifications",
        "safariNotificationStatus": "Statut actuel de la permission : ",
        "discoverDesign": "Choisissez votre style d’interface",
        "backDashboard": "Aller Au Tableau De Bord",
        "suspendNow": "Suspendre",
        "unsuspendNow": "Réactivez"
      },
      homepage: {
        banner: {
          titleAcheive: "Notre Force Ensemble",
          acheive: "Pour achever nos buts.",
          titleTeam: "Travails d'Équipe",
          team: "Complicité & Atmosphère",
          titleProd: "Planifier avec les RH",
          prod: "Productivité et efficience pour être efficace"
        },
        card: {
          "hr": "Resources Humaines",
          "hr_content": "Centralizez vos ressources humaines. Dossiers d'intégration des employés et analyses. Suivez les heures de travails de vos employés. Pointer vos heures, feuille de temps.",
          "work": "Heures de travails",
          "work_content": "Suivez les heures de travails de vos employés. Pointer vos heures, feuille de temps.",
          "stat": "Analysez vos équipes",
          "stat_content": "Attribuez des points à vos employés et analysez leurs forces pour améliorer vos services. Le moyen le plus simple d'optimiser l'utilisation de vos employés.",
          "communication": "Améliorez la communications",
          "com_content": "Clavardage, nouvelles internes, et notifications automatiques. Vous pouvez également demander des requêtes et échangez vos quarts de travails entre collègues.",
          "more_details": "Plus de Détails",
        },
        "start_scheduling": "Planifiez les tâches",
        "in_minutes": "maintenant",
        "try_free": "Essayez gratuitement",
        help_video: "Exemples Vidéo",
      },
      signup: {
        "type_invalid": "Ce type est invalide.",
        "type_required": "Vous devez choisir un type.",
        "accepted_terms_required": "Vous devez accepter les termes et conditions ainsi que la politique de confidentialité.",
        "username_required": "Le nom d'utilisateur est requis",
        "username_invalid": "Le nom d'utilisateur ne peut contenir que des lettres, chiffres, espaces, underscores ou tirets",
        "email_invalid": "Le courriel est invalide.",
        "email_required": "Le courriel est requis.",
        "password_required": "Le mot de passe est requis.",
        "password_min": "Le mot de passe doit contenir au moins 8 caractères.",
        "password_repeat_required": "Veuillez confirmer le mot de passe.",
        "password_mismatch": "Les mots de passe ne correspondent pas.",
        "password_complexity": "Inclure au moins 1 majuscule, 1 minuscule, 1 chiffre et 1 caractère spécial.",
        "createTitle": "Creer Votre Compte d'Utilisateur",
        "name": "Nom",
        "email": "Courriel",
        "password": "Mot de Passe",
        "repeat_password": "Répéter le Mot de Passe",
        "password_error_title": "Erreur de Mot de Passe",
        "password_error_message": "Le mot de passe ne fonctionne pas.",
        "account_create_title": "Compte Créé avec Success",
        "account_create_message": "Confirmer votre courriel avec le message que nous vous avons envoyé.",
        "registration_error": "Erreur de Subcription",
        "register": "Enregistrer",
        "register_form": "Formulaire d'Enregistrement",
        "send": "Envoyer",
        "loading": "Patienter ...",
        "forget_password": "Mot de passe oublié",
        "code": "Code",
        "new_password": "Nouveau mot de passe",
        "resetPasswordTitleAlert": "Refaire Mot De Passe",
        "resetPasswordAlertMessage": "Nous vous avons envoyé un courriel à ",
        "error": "Erreur",
        "badEmail": "Entrer un courriel valide",
        "newPasswordTitleAlert": "Changement Accepté",
        "newPasswordAlertMessage": "Nouveau mot de passe accepté",
        "login_form": "Formulaire de connexion",
        "goToForgotPassword": "Mot de passe oublié?",
        "EmailConfirmSuccessTitle": "Confirmation de Courriel Réussi",
        "EmailConfirmSuccessMessage": "Bienvenue dans vos outils Schedulum.",
        "EmailConfirmErrorTitle": "Erreur de Confirmation de Courriel",
        "warning": "Attention",
        "enterEmail": "Entrer votre courriel pour obtenir le code de confirmation",
        "codeSended": "Code de confirmation envoyé",
        "watchMailbox": "Regardez dans votre boîte de courriel",
        "codeError": "Erreur de code de confirmation",
        "confirmEmail": "Confirmer votre courriel",
        "confirmEmailLink": "Aller au courriel de confirmation",
        "resendCode": "Renvoyer un code",
        "confirmEmailForm": "Confirmer Votre Courriel",
        "type_title": "Type Invalide",
        "type_message": "Selectionner un type d'utilisateur",
        "agree_to": "J'accepte les",
        "terms_of_use": "Conditions d'utilisation",
        "privacy_policy": "Politique de confidentialité",
        "and": "et",
        "acceptedTermsTitle": "Termes & Conditions avec Politique sur la vie privé",
        "acceptedTermsMessage": "Vous devez accepter les termes et conditions ainsi que la politique sur la vie privé"
      },
      profile: {
        "deleteAccount": "Supprimer le compte",
        "deleteMessage": "Aucun retour en arrière n'est possible ... Êtes-vous sûr de vouloir supprimer votre compte?",
        create_company: "Ajouter une Entreprise",
        add_worker: "Ajouter des travailleurs",
        linkedCompanyTitle: "Lien d'entreprise",
        linkedCompany: "... Vous devez être associé à une entrerpise ...",
        choose_plan: "Choisir un forfait",
        choose_plan_MACOS: "Votre company doit choisir un forfait",
        change_plan: "Changer de forfait",
        shifts: "Quarts de travails",
        "error_uploading_image": "Erreur lors du téléchargement de l'image",
        "warning": "Warning",
        "provideUsername": "Donner un nom d'utilsateur",
        "fileTooLargeTitle": "Fichier trop gros", 
        "fileTooLarge": "Choisisser un fichier ne dépassant pas 5MB",
        "noWorkingHours": "Aucun heure du tout",
        "10Hours": "10 heures de travails",
        "20Hours": "20 heures de travails",
        "30Hours": "30 heures de travails",
        "40Hours": "40 heures de travails",
        "50Hours": "50 heures de travails",
        "60Hours": "60 heures de travails",
        "70Hours": "70 heures de travails",
        "80Hours": "80 heures de travails",
        "90Hours": "90 heures de travails",
        "english": "Anglais",
        "french": "Français",
        "changePicture": "Changer Votre Photo",
        "username": "Identifiant",
        "firstname": "Prénom",
        "lastname": "Nom de Famille",
        "phoneNumber": "Téléphone",
        "preferences": "Préférences",
        "availabilities": "Disponibilités",
        "night": "Nuit",
        "monday": "Lundi",
        "tuesday": "Mardi",
        "wednesday": "Mercredi",
        "thursday": "Jeudi",
        "friday": "Vendredi",
        "saturday": "Samedi",
        "sunday": "Dimanche",
        "submitting": "Soumission...",
        "submit": "Soumettre",
        "startPlaceholder": "Entrer votre ",
        "usernameRequired": "Username requis",
        "usernameRequiredMessage": "Username doit avoir au moins 3 caractères",
        "lastnameRequired": "Nom de famille requis",
        "lastnameRequiredMessage": "Le nom de famille doit avoir au moins 3 caractères",
        "firstnameRequired": "Prénom requis",
        "firstnameRequiredMessage": "Le Prénom doit avoir au moins 3 caractères",
        "editProfile": "Editer Profile",
        "language": "Langage",
        "becomeManager": "Promouvoir Gestionaire",
        "becomeEmployee": "Rétograder Employé",
        "promoteManager":"Voulez-vous vraiment promouvoir cet employé comme gestionnaire?",
        "promoteEmployee": "Voulez-vous vraiment rétograder ce gestionnaire en simple employé?",
        "suspendWorker": "Voulez-vous vraiment suspendre cet employé?",
        "unsuspendWorker": "Voulez-vous vraiment réactiver cet employé?"
      },
      company: {
        "createTitle": "Creer Votre Compte d'Entreprise",
        "name": "Nom",
        "email": "Courriel",
        "address": "Adresse",
        "phone": "Téléphone",
        "password": "Mot de Passe",
        "repeat_password": "Répéter le Mot de Passe",
        "password_error_title": "Erreur de Mot de Passe",
        "password_error_message": "Le mot de passe ne fonctionne pas.",
        "account_create_title": "Entreprise Créé avec Succès",
        "account_create_message": "Ajouter des employés et utilisé les outils que Schedulum met a votre disposition.",
        "registration_error": "Erreur de Subcription",
        "register": "Enregister",
        "only_one_account_title": "Entreprise déjà existante",
        "only_one_account_message": "Vous pouvez avoir seulement 1 entreprise par compte",
        "startPlaceholder": "Entrer le ",
        "stopPlaceholder": " de la compagnie",
        "nameRequired": "Nom requis",
        "nameRequiredMessage": "Nom doit avoir au moins 3 caractères",
        "phoneNumberRequired": "Téléphone requis",
        "phoneNumberRequiredMessage": "Le téléphone doit avoir au moins 7 caractères",
        "addressRequired": "Adresse requise",
        "addressRequiredMessage": "L'adresse doit avoir au moins 3 caractères",
        "phoneFormatError": "Le format du numéro de téléphone doit être 000-000-0000"
      },
      scheduler: {
        "day": "Jour",
        "week": "Semaine",
        "month": "Mois",
        "all_shifts": "Tout les Quarts",
        "all_users": "Tout les Utilisateurs",
        "all_users_short": "Tous",
        deleteShiftTitle: "Supprimer un quart",
        deleteShiftMessage: "Voulez-vous vraiment supprimer ce quart?",
      },
      agenda: {
        "noShift": "Aucun événement pour cette semaine.",
        "info": "Info",
        "infoTitle": "Information",
        "selectDate": "Sélectionner une date",
      },
      user: {
        "username": "Nom d'Utilisateur",
        "email": "Courriel",
        "hours": "Heures",
        "night": "Nuit",
        "monday": "Lundi",
        "tuesday": "Mardi",
        "wednesday": "Mercredi",
        "thursday": "Jeudi",
        "friday": "Vendredi",
        "saturday": "Samedi",
        "sunday": "Dimanche",
        "isConfirmed": "Est Confirmé",
      },
      table: {
        "excel_title": "Colle la table Excel table ici :",
        "upload_excel_title": "Verser un fichier Excel :",
        "shift_create": "Shifts à créer :",
        "open_shift_create": "Quarts ouvert à créer :",
        "shift_example": "Exemple de Shift :",
        "open_shift_example": "Exemple de Quarts ouvert ( PUBLIC ) :",
        "shift_tip": "Nous allons ignorer la première ligne de la table que vous allez coller ( ligne de titre pour chaque colonnes )",
        "users_list": "Liste d'Utilisateur",
        "placeholder": "Collez ici avec Ctrl+V",
        "upload_box1": "Glissez-déposez un fichier ici ou ",
        "upload_box2": "cliquez pour parcourir",
      },
      braintree: {
        pay: "Payer",
        locale: "fr_CA",
        "paymentSuccessTitle": "Paiement Accepté",
        "paymentSuccessMessage": "Le paiement a procédé avec success",
        "noPaymentTitle": "Échec de Paiement",
        "noPaymentMessage": "Le paiement n'a pas procédé correctement",
      },
      stripe: {
        locale: "fr",
        successTitle: "Paiement Schedulum Accepté",
        successMessage: "Le paiement a procédé avec success",
        stripeCancelScreen: "Paiement Stripe Cancellé", 
        stripeSuccessScreen: "Paiement Stripe Accepté",
        free: {
          title: "Plan Gratuit",
          promoCode: "Code Promotionnel", 
          create: "Essayez notre plan gratuit",
          atleast_one_character: "Vous devez entrer un code promotionnel.",
          alreadyComId: "Vous êtes déjà associé à une entreprise",
          freeError: "Erreur de plan gratuit",
        },
        trial: {
          description: "Avec un essaie gratuit de  30 jours."
        },
        starter: {
          name: "Abonnement Starter",
          description: "Accédez à toutes les fonctionnalités. Abonnement pour 10 travailleurs maximum.",
          price: "15,00$ / mois",
        },
        essential: {
          name: "Abonnement Essential",
          description: "Accédez à toutes les fonctionnalités. Abonnement pour 20 travailleurs maximum.",
          price: "30,00$ / mois",
        },
        plus: {
          name: "Abonnement Plus",
          description: "Accédez à toutes les fonctionnalités. Abonnement pour 30 travailleurs maximum.",
          price: "45,00$ / mois",
        },
        advanced: {
          name: "Abonnement Advanced",
          description: "Accédez à toutes les fonctionnalités. Abonnement pour 40 travailleurs maximum.",
          price: "60,00$ / mois",
        },
        pro: {
          name: "Abonnement Pro",
          description: "Accédez à toutes les fonctionnalités. Abonnement pour 50 travailleurs maximum.",
          price: "75,00$ / mois",
        },
        business: {
          name: "Abonnement Business",
          description: "Accédez à toutes les fonctionnalités. Abonnement pour 80 travailleurs maximum.",
          price: "120,00$ / mois",
        },
        premium: {
          name: "Abonnement Premium",
          description: "Accédez à toutes les fonctionnalités. Abonnement pour 100 travailleurs maximum.",
          price: "150,00$ / mois",
        },
        elite: {
          name: "Abonnement Elite",
          description: "Accédez à toutes les fonctionnalités. Abonnement pour 150 travailleurs maximum.",
          price: "225,00$ / mois",
        },
        ultimate: {
          name: "Abonnement Ultimate",
          description: "Accédez à toutes les fonctionnalités. Abonnement pour 200 travailleurs maximum.",
          price: "300,00$ / mois",
        },
        infinity: {
          name: "Abonnement Infinity",
          description: "Accédez à toutes les fonctionnalités. Abonnement pour un nombre illimité travailleurs maximum.",
          price: "450,00$ / mois",
        },
        subscribing: "S'abonner",
      },
      worker: {
        email_invalid: "Courriel Invalide",
        email_required: "L'email est obligatoire",
        create_title: "Creation De Travailleurs",
        create_message: "Travailleurs créer avec succès",
        create_error: "Erreur de Creation de Travailleur",
        delete_error: "Erreur Pour Supprimer Un Travailleur",
        delete_error_message: "Ce travailleur est associé à cette entreprise",
        create_no_new_worker: "Aucun nouveau travailleur n'a été créer",
        workers_list_title: "Liste De Travailleurs",
        addWorkerForm: "Formulaire d'ajout de travailleurs",
        coworkers: "Collègues",
        writeSearch: "Rechercher un collègues",
        create_max_10_workers: "Vous ne pouvez pas créer plus de 10 travailleurs avec ce plan",
        create_max_20_workers: "Vous ne pouvez pas créer plus de 20 travailleurs avec ce plan",
        create_max_30_workers: "Vous ne pouvez pas créer plus de 30 travailleurs avec ce plan",
        create_max_40_workers: "Vous ne pouvez pas créer plus de 40 travailleurs avec ce plan",
        create_max_50_workers: "Vous ne pouvez pas créer plus de 50 travailleurs avec ce plan",
        create_max_80_workers: "Vous ne pouvez pas créer plus de 80 travailleurs avec ce plan",
        create_max_100_workers: "Vous ne pouvez pas créer plus de 100 travailleurs avec ce plan",
        create_max_150_workers: "Vous ne pouvez pas créer plus de 150 travailleurs avec ce plan",
        create_max_200_workers: "Vous ne pouvez pas créer plus de 200 travailleurs avec ce plan",
        atleast_one_email: "Vous devez entrer au moins un courriel de travailleur",
      },
      shift: {
        title: 'Titre: ',
        role: "Rôle: ",
        location: "Endroit: ",
        information: "Information: ",
        startAt: "Débute à: ",
        stopAt: "Termine à: ",
        dragUpdateTitle: "Voulez-vous modifier ce quart?",
        dragUpdatestartAt: "Il débutera  à: ",
        dragUpdatestopAt: "Il finira à: ",
        deleteTitle: "Voulez-vous supprimer ce quart?",
        deleteMessage: "Après avoir supprimé ce quart il sera perdu pour toujours",
        areYouSure: "Êtes-vous certain?",
        acceptedMessage: "Voulez-vous vraiment accepté ce quart de travails?",
        deletedMessage: "Voulez-vous vraiment supprimer ce quart de travails?",
        confirmedMessage: "Voulez-vous vraiment confirmé ce quart de travails?",
        unconfirmedMessage: "Do you want to unconfirm this shift?",
        awaitingConfirmation: "...Confirmation En Attente",
        accepted: "Accepté",
        notAccepted: "Non Accepté",
        confirmed: "Comfirmé",
        confirm: "Confirmer",
        unconfirm: "Déconfirmer",
        accept: "Accepter",
        worker: "Travailleur: ",
        update: "Modifier",
        cancel: "Canceler",
        delete: "Suprimer",
        create: "Créer",
        save: "Sauvegarder",
        showDetails: " ... Voir Détails ... ",
        new: "New",
        select: "-- Sélectionnez --",
        goTo: "Naviguer au quart de travails",
        "quality": "Qualité",
        "performance": "Performance",
        "punctuality": "Ponctualité",
        "rate": "Note",
        "honor": "Prix",
        "distance_km": "Km",
        "star": "étoile(s)",
        "rankShiftTitle": "Évaluer le Quart",
        "formSubmit": "Votre Évaluation",
        "formHonorSubmit": "Votre Récompense",
        "rankUpdate": "Sauvegarder",
        "saveRank": "Enregistrer l'évaluation",
        "honorShiftTitle": "Récompenser l'Employé",
        "errorAcceptingShift": "Erreur lors de l'acceptation du quart",
        "publicRadio": "Sélectionner Pour Envoi Public",
        "roundMedal": "Médaille d'Endurance et de Ponctualité",
        "starMedal": "L'étoile de l'assistance et de la sécurité",
        "trophy": "Coupe de l'Excellence et de la Performance",
        "trophy2": "Trophé Emblématique De l'employé du Mois",
        "noGeolocation": "Location ne produit aucune geolocatisation",
        "ai_rec_button": "Recommendation d'IA",
        "AIrecError": "L'IA est entrainé chaque mois, merci d'être patient",
        "addressLocationTitle": "Suggestion d'Adresse",
        "addressLocationMessage": "Voulez-vous modifier votre adresse pour l'adresse suggéré: ",
        "addressLocationMessage1": "Adresse actuelle: ",
        "addressLocationMessage2": "Adresse Suggéré: ",
        "addressLocationUSE": "Utiliser l'Adresse Suggéré",
        "addressLocationKEEP": "Conserver l'Adresse",
        "addressNotFoundTitle": "Adresse Non Trouvé",
        "addressNotFoundMessage": "L'adresse n'a pas été identifié, voulez-vous la modifier ?",
        "addressNotFoundContinue": "Continuer Sans Modification",
        "addressNotFoundModify": "Modifier l'Adresse",
        "geoFoundTitle": "Geolocalisation Identifié",
        "geoFoundMessage": "LA GEOLOCALISATION EST TRÈS UTILE POUR LES SUGGESTIONS DE L'IA!",
        "geoFoundMessage1": "Voulez-vous utiliser la geolocalisation trouvé de l'adresse suggéré ?",
        "geoFoundLatitude": "Latitude: ",
        "geoFoundLongitude": "Longitude: ",
        "geoFoundDONT": "Sans Coordonnés",
        "geoFoundUSE": "Utiliser Les Coordonnés",
        "getGeoData": "Geolocation",
        "publicCheckbox": "Public",
        "errorGeo": "Veuillez entrer une adresse",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "moreUserTitle": "Utilisateurs Supplémentaires",
        "seeMoreUsers": "Si vous voulez voir plus d'utilisateurs vous devez utiliser la pagination",
        "previousUser": "Utilisateurs Précédents",
        "nextUser": "Utilisateurs Suivants",
      },
      punch: {
        "at": "Pointé à: ",
        "location": "Endroit du pointage",
        "close": "Fermer",
        "details": "Pointage en détails",
        "punchSaveTitle": "Pointage Enregistré",
        "punchSaveErrorTitle": "Erreur de pointage",
        "punchSaveMessage": "Merci, votre pointage a été sauvegardé",
        "punchSaveErrorMessage": "Votre pointage n'a pas été sauvegardé, assurez-vous d'avoir autorisé la géolocalisation",
      },
      post: {
        areYouSure: "Êtes-vous certain?",
        deleteMessage: "Voulez-vous vraiment supprimer ce message",
        writeComment: "Écriver un Commentaire",
        pleaseWriteComment: "Écriver a votre équipe",
        pleaseWriteCommentCoWorker: "Écriver a votre collègue",
        submit: "Soumet",
        delete: "Supprimer",
        createdAt: "Créé le: ",
        "deletedMessage": "Voulez-vous supprimer ce message?",
        "deleteOrChangeTitle": "Supprimer ou Changer L'image",
        "deleteOrChangeMessage": "Voulez-vous supprimer ou changer cette image?",
        "imageChange": "Changer L'image",
        "imageDelete": "Supprimer l'Image"
      },
      document: {
        areYouSure: "Êtes-vous certain?",
        deleteMessage: "Voulez-vous vraiment supprimer ce document",
        importFileBtn: "Importer un fichier",
        selectFile: "Sélectionner un fichier",
        sizeTitle: "Votre fichier excède la limite",
        sizeMessage: "Votre fichier ne doit pas excèder 5MB",
      },
      billing: {
        pick_subscription: "Choisissez votre abonnement",
        subscription: "Abonnement pour un maximum de ",
        workers: " travailleurs",
        price: "Prix: ",
        by_mount: "$ / mois",
      },
      detail: {
        title: "Détails du planificateur",
        rhTitle: "Un temps d’avance sur la planification",
        rhMessage: "Maîtrisez la planification et le suivi du temps de travail avec une solution tout-en-un, intuitive et puissante. Notre application vous permet de structurer le quotidien de vos équipes avec une efficacité inégalée.",
        rhSpreadsheetTitle: "Utiliser nos créations simplifié",
        rhSpreadsheetMessage: "<p>Télécharger vos quarts de travails via des fichiers de tableur, comme Microsoft Excel, LibreOffice Spreadsheet ou simplement par un simple fichier \"CSV\". Utiliser seulement la bonne mise en page et le tour est joué.</p><p>Vous pouvez également coller une copie de quelques lignes, plutôt que dèenvoyer un fichier complet ou utiliser les méthodes que l'application vous offres pour créer des quarts de travails à partir de rien.</p>",
        rhGPSTitle: "Suivez les heures de travail avec précision",
        rhGPSMessage: "<p>Grâce à notre système de pointage, vos employés peuvent facilement enregistrer leurs heures, avec une géolocalisation GPS pour assurer un suivi fiable des présences sur le terrain.</p><p>Consultez les feuilles de temps en temps réel, automatisez le suivi des heures travaillées, améliorez la transparence et simplifiez la gestion de la paie. Toutes les données sont centralisées, accessibles et prêtes à être utilisées pour vos analyses et rapports.</p>",
        timeTitle: "Planification Intelligente des Équipes",
        timeMessage: "<p>Planifiez efficacement les horaires et les tâches de vos employés. Notre application permet aux responsables des ressources humaines d’organiser le travail de manière structurée et intuitive.</p><p>Grâce à un système de planification centralisé, vous pouvez assigner les horaires, suivre les tâches et obtenir une vue d’ensemble en temps réel de l’activité de votre entreprise.<p><p>Les statistiques générées offrent une perspective claire sur la productivité, les performances et l’organisation interne, facilitant ainsi la prise de décision et l’optimisation des opérations.<p>",
        statTitle: "Visualisez la performance en un coup d’œil",
        statMessage: "Suivez les heures travaillées, les absences, les retards et les heures supplémentaires grâce à des graphiques clairs et des statistiques en temps réel. En un regard, identifiez les tendances et optimisez l’organisation de vos équipes. Gagnez en visibilité, ajustez les plannings facilement et appuyez vos décisions sur des données concrètes, accessibles directement depuis l’application.",
        heatmapTitle: "Carte thermique pour l'analyse des forces des employés",
        heatmapMessage: "<p>La heatmap est un outil visuel puissant permettant de représenter rapidement la qualité, la performance, la ponctualité et le taux de satisfaction des collaborateurs sur leurs shifts.</p><p>Grâce aux variations de couleurs, il devient facile d’identifier en un coup d'œil les forces et les faiblesses des équipes ou des collaborateurs spécifiques.La heatmap aide les managers à cibler immédiatement les axes d’amélioration sans avoir à parcourir des tableaux de chiffres complexes.</p><p>Elle met en évidence les tendances par utilisateur ou par période, ce qui facilite l’analyse des shifts réussis et des points à corriger.En visualisant les contributions positives (zones vertes), les entreprises peuvent valoriser les bons éléments, renforcer l’engagement et instaurer une culture de l’amélioration continue.</p>",
        recommendationTitle: "Recommandations intelligentes pour vos quarts de travail",
        recommendationMessage: "<p>Vous pouvez désormais bénéficier de recommandations basées sur l’intelligence artificielle pour sélectionner les meilleurs employés pour vos quarts de travail.</p><p>Cette intelligence artificielle est mise à jour mensuellement. Ses recommandations et prédictions s'affinent au à mesure que vous attribuez et évaluez les quarts de travail de vos employés.</p><p>Cette intelligence artificielle prend en compte plusieurs critères clé: </p><ul><li style='padding-bottom: 15px;'>Les disponibilités individuelles des employés (jours et quarts travaillés précédemment)</li><li style='padding-bottom: 15px;'>Les lieux de pointage historiques (présence géographique, régularité, mobilité)</li><li style='padding-bottom: 15px;'>Les évaluations de performance que vous avez attribuées aux quarts passés</li><li style='padding-bottom: 15px;'>Les distinctions et reconnaissances que vous leur avez décernées (ex. : employés du mois, mentions spéciales, etc.)</li></ul><p>Grâce à ces données, l’Intelligence artificielle peut vous suggérer automatiquement les meilleurs profils pour chaque quart à pourvoir — en tenant compte à la fois de la performance, de la fiabilité et de la compatibilité horaire.</p>",
        boxplotTitle: "Suivez les heures de travail avec précision",
        boxplotMessage: "<p>Le boxplot est un outil statistique visuel très utile pour analyser la répartition et la variabilité des indicateurs tels que la qualité, la performance, la ponctualité et le taux de satisfaction des shifts.</p><p>Le boxplot montre facilement comment les notes varient pour chaque indicateur : médiane, quartiles, valeurs extrêmes. Cela permet de détecter rapidement les écarts anormaux ou récurrents.Les points isolés au-dessus ou en-dessous de la boîte indiquent des shifts inhabituels (très bons ou très mauvais), permettant d’investiguer des cas particuliers.</p><p>En affichant côte à côte les boxplots de quality, performance, punctuality et rate, les entreprises visualisent immédiatement quel aspect est le plus stable ou le plus variable dans le temps ou par utilisateur.Grâce à ces insights visuels, les managers peuvent cibler les indicateurs les plus volatils et définir des plans d’amélioration ciblés pour leurs équipes.</p>",
        barplotTitle: "Le graphique à barres compare les valeurs moyennes",
        barplotMessage: "<p>Le diagramme en barres, est un outil simple et visuel permettant de comparer des valeurs moyennes ou globales sur différents indicateurs de performance, tels que la qualité, la performance, la ponctualité et le taux de satisfaction des shifts.</p><p>Un barplot permet de voir en un coup d'œil comment se positionnent les indicateurs clés sur une échelle de 0 à 5. Il rend très lisible quel critère est le mieux noté (ex : qualité) et lequel demande plus d'attention. En représentant côte à côte les valeurs moyennes de quality, performance, punctuality et rate, le barplot facilite la comparaison directe des forces et des faiblesses globales.</p><p>Si la performance ou la ponctualité apparaît en-dessous des autres indicateurs, l’entreprise peut prioriser des actions correctives ciblées sur ces aspects précis. Le diagramme en barres est un excellent support visuel pour des présentations en comité de direction, car il synthétise des informations complexes de manière immédiate et accessible.</p>",
        spyderradarTitle: "Le diagramme radar indique plusieurs indicateurs simultanément",
        spyderradarMessage: "<p>Le diagramme radar, est un outil de visualisation puissant qui permet de représenter plusieurs indicateurs simultanément sous forme de toile d’araignée. Pour vos clients, cet outil apporte une lecture globale et comparative des shifts sur des critères comme la qualité, la performance, la ponctualité et le taux de satisfaction (rate)</p><p>Contrairement aux barres ou courbes séparées, le radar chart montre tous les indicateurs en même temps sur un seul graphique circulaire. Cela permet de voir immédiatement si un profil est \"équilibré\" ou s’il y a des axes faibles ou forts. Les écarts entre les différentes branches du radar permettent d’identifier rapidement les axes de progrès prioritaires (ex : la ponctualité est en retrait par rapport à la qualité).</p><p>Superposer plusieurs radars (par utilisateur ou par période) permet de comparer facilement les performances individuelles ou l’évolution dans le temps. Le radar chart est très visuel et apprécié dans les réunions car il simplifie la lecture d’indicateurs complexes, même pour un public non-expert en data.</p>",
        communicationTitle: "Renforcez la communication interne",
        communicationMessage: "Améliorez la collaboration entre vos équipes grâce à notre système intégré de clavardage, de diffusion de nouvelles internes et de notifications automatiques. Que ce soit pour partager des mises à jour, coordonner des tâches ou informer rapidement vos employés, notre plateforme assure une communication fluide, centralisée et efficace. Gardez tout le monde informé, engagé et aligné, où qu’ils soient.",
        comPostTitle: "Communiquez en temps réel",
        comPostMessage: "<p>Discutez instantanément avec vos collègues grâce à notre messagerie intégrée. Que ce soit pour échanger en privé ou discuter en groupe, vous restez connectés à tout moment, sans avoir à passer par des outils externes. Les conversations sont organisées, sécurisées et toujours accessibles depuis l’application.</p><p>Cette fonctionnalité favorise la réactivité et la coordination entre les membres de l’équipe, notamment pour les changements de planning, les urgences ou les annonces importantes. Plus besoin d’attendre un e-mail ou de passer un appel : l’information circule rapidement, dans le bon contexte. Restez alignés, même à distance, et renforcez la collaboration au quotidien.</p>",
        comLeaveTitle: "Gérez vos congés sans friction",
        comLeaveMessage: "<p>Avec notre application, faire une demande de congé devient simple et rapide. En quelques clics, soumettez vos dates souhaitées, ajoutez un commentaire si nécessaire, et suivez le statut de votre demande en temps réel. Fini les formulaires papier ou les allers-retours par e-mail : tout est centralisé et automatisé.</p><p>Les responsables reçoivent une notification instantanée et peuvent approuver ou refuser en un clin d’œil. Le calendrier est automatiquement mis à jour, ce qui permet à l’ensemble de l’équipe de visualiser les absences à venir et de mieux anticiper l’organisation du travail. Résultat : moins d’erreurs, plus de clarté, et une gestion des congés plus fluide pour tous.</p>",
        comSwapTitle: "Partagez vos quarts facilement",
        comSwapMessage: "<p>Transférez un quart de travail à un collègue en quelques clics. Sélectionnez le quart, choisissez la personne disponible, et la demande est envoyée. Une fois acceptée, le planning est automatiquement mis à jour, sans erreur ni confusion.</p><p>Cette fonctionnalité simplifie les échanges entre collègues, améliore la réactivité face aux imprévus et réduit le stress lié aux changements de dernière minute. Elle offre une gestion souple et efficace, tout en maintenant une organisation claire et fluide. Restez connectés, flexibles et synchronisés avec votre équipe.</p>",  
      },
      request: {
        swapMessage: "Voulez-vous vraiment transférer ce quart à ",
        leaveMessage: "Voulez-vous vraiment envoyez cette demande de congé?",
        transfer: "Transférer",
        submitRequest: "Soumettre la requête de transfert",
        transferSwapTitleForm: "Formulaire de Transfert",
        transferLeaveTitleForm: "Demande de Congé",
        start: "Date de début",
        stop: "Date de fin",
        createLeave: "Demandez le congé",
        transferTo: "Transférer à:",
        request_error: "Erreur de requête",
        transfered: "Transferé",
        alreadySwaped: "Ce transfert a été effectué",
        transfer_awaiting: "Transfert en attente ...",
        chooseTitle: "Sélectionnez le type de requête",
        chooseMessage: "Vous pouvez envoyer et consulter vos demandes de congé ainsi que de voir vos quarts à transférer",
        swapLink: "Transfert de Quarts",
        askLink: "Demandes de congé",
        swapManagerLink: "Gestion des transferts de Quarts",
        askManagerLink: "Gestion des demandes de congé",
        noRequest: "Aucune requête disponible",
        giveTab: "Quarts donnés",
        receiveTab: "Quarts Disponibles",
        managerTab: "Transferts (MANAGER)",
        leaveTab: "Vos congés demandés",
        createLeaveTab: "Demandez un congé",
        managerLeaveTab: "Congés (MANAGER)",
        ask: "Demandez",
        acceptMessage: "Voulez-vous vraiment accepter cette demande de congé?",
        deleteMessage: "Voulez-vous vraiment supprimer cette demande de congé?"
      },
      suspended: {
        accountSuspended: "Votre compte a été suspendu",
        contactCompany: "Contacter votre company pour rectifier la situation dans le futur",
        tryAgain: "Essayer Encore",
        noCompany: "Aucune Entreprise Trouvé",
        noAccountTitle: "Aucune abonnement Trouvé",
        noAccount: "Votre entreprise doit s'abonner a un plan"
      },
      blog: {
        searchPlaceholder: "Recherche de posts...",
      },
      toast: {
        welcome: "Bienvenue ",
        companyNeeded: "Vous devez enregistrer une entreprise",
        shiftCreated: "Un quart de travail a été créé avec succès",
        shiftUpdated: "Un quart de travail a été modifié avec succès",
        shiftDeleted: "Un quart de travail a été supprimé avec succès",
        openShiftCreated: "Un quart de travail public a été créé avec succès",
        openShiftDeleted: "Un quart de travail public a été supprimé avec succès",
        openShiftUpdated: "Un quart de travail public a été modifié avec succès",
        confirmEmailTitle: "Votre compte a été créé avec succès",
        confirmEmail: "Veuillez confirmer votre courriel",
        firstConnectTitle: "Votre email a été confirmé",
        firstConnect: "Connectez-vous à votre compte dès maintenant",
        editProfile: "Votre profile a été modifié avec succès",
        editCompany: "Votre compagnie a été modifié avec succès",
        leaveCreated: "Votre demande de congé a été créé avec succès",
        leaveAccepted: "Une demande de congé a été accepté avec succès",
        leaveDeleted: "Une demande de congé a été supprimé avec succès",
        swapCreated: "Votre demande de transfer de quart de travail a été créé avec succès",
        swapAccepted: "Une demande de transfer de quart de travail a été accepté avec succès",
        swapDeleted: "Une demande de transfer de quart de travail a été supprimé avec succès",
        companyRestrictedTitle: "Zone d'accès Limité",
        companyRestricted: "La zone demandée est restrainte"
      },
      help: {
        title: "Exemples Vidéo",
        moreTitle: "Plus D'Options",
        helpTitle: "Liste D'Aide",
        shiftCreate: "Creation De Quart",
        openShiftCreate: "Creation De Quart Ouvert (PUBLIC)",
        pasteSpreadsheet: "Coller Des Quarts Avec Un Tableur",
        uploadSpreadsheet: "Enregistrer Des Quarts Avec Un Tableur",
        editShift: "Editez Et Transférez Un Quart",
        transferShift: "Transférez Un Quart",
        deleteShift: "Suppriémez Un Quart",
        clockIn: "Pointez Sur Un Quart De Travail",
        uploadDocument: "Enregistrez Un Document",
        leaveRequest: "Demandez un congé",
        shiftTitle: "Comment créer ou supprimer des quarts",
        shiftMessage: "Voici des exemples de création de quarts de travail ou de quarts ouverts (PUBLIC). Vous pouvez créer un quart de travail à la fois ou plusieurs quarts de travail à l'aide d'une feuille de calcul. Vous trouverez également un exemple de suppression de quart de travail et des vidéos montrant comment modifier ou transférer un quart de travail à un autre employé.",
        miscTitle: "Comment utiliser certaines options",
        miscMessage: "Voici des exemples de différentes options. Vous apprendrez à pointer votre arrivée et votre départ. Vous trouverez un exemple d'envoi de document à un employé, ainsi qu'une vidéo expliquant comment demander un congé.",
      },
      ai_chatbox: {
        title_box: "Assistant IA en ligne",
        placeholder_box: "Discutez avec l'IA tout en naviguant sur le site.",
        placeholder: "Bonjour! Comment puis-je vous aider aujourd'hui?",
        llm_error: "Erreur lors de la communication avec le LLM:",
        error: "Désolé, une erreur est survenue lors de la communication avec le serveur.",
        input_placeholder: "Ecrivez un message...",
        send: "Envoyer",
        confirm_clear: "Voulez-vous vraiment vider l'historique des discussions ?",
        clear_history: "Vider l'historique des discussions",
        clear: "Vider",
      }

    },
  }
};

i18n
  .use(initReactI18next) // passe i18n à react-i18next
  .init({
    resources,
    lng: 'en', // Langue par défaut
    fallbackLng: 'en', // Langue de secours si la langue choisie n'est pas disponible
    interpolation: {
      escapeValue: false // React gère déjà la sécurité des données
    }
  });

export default i18n;